import { faLocationDot } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import i18next from "i18next"
import type { ListItem } from "../../components/List/List"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { ServicePoints } from "../ServicePoint/ServicePoints"
import { MemoryClass } from "./MemoryClass"

export class MemoryServicePoints extends MemoryClass<ServicePoints> {
  setList(items: ServicePoints[]): void {
    this.listData = items
  }

  protected cloneEntity(item: ServicePoints): ServicePoints {
    return new ServicePoints({ ...item })
  }

  getListCards(all: boolean): ListItem[] {
    return this.listData
      .filter((servicePoint) => all || servicePoint.status === EEnableStatusType.Active)
      .map((servicePoint, index) => this.getCard(servicePoint, index))
  }

  getCard(servicePoint: ServicePoints, index: number): ListItem {
    const isActive = servicePoint.status === EEnableStatusType.Active
    const isOccupied = servicePoint.isOccupied || servicePoint.hasCustomer
    const cardColor = isOccupied
      ? "bg-red-50 border-2 border-red-300 hover:shadow-md hover:scale-[1.01]"
      : isActive
        ? "bg-white border border-slate-200 hover:shadow-md hover:scale-[1.01]"
        : "bg-slate-100 border border-slate-200 opacity-80"
    const iconColor = isOccupied ? "bg-red-600" : isActive ? "bg-slate-500" : "bg-slate-400"

    return {
      isDisable: !isActive,
      id: servicePoint.id,
      title: servicePoint.name,
      linkImage: "",
      index,
      dataFilter: [
        servicePoint.id.toString(),
        servicePoint.name,
        servicePoint.description,
        servicePoint.status.toEnableStatusTypeString(),
        isOccupied ? i18next.t("servicePoints:status_occupied") : i18next.t("servicePoints:status_free"),
      ],
      children: (
        <div
          className={`flex items-center justify-between rounded-2xl p-3 transition-all duration-200 ${cardColor}`}
        >
          <div className="flex items-center gap-4">
            <div
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-2xl font-bold text-white ${iconColor}`}
            >
              <FontAwesomeIcon icon={faLocationDot} />
            </div>

            <div className="flex flex-col gap-1">
              <span className="text-sm font-semibold uppercase text-gray-800">
                <FontAwesomeIcon icon={faLocationDot} className="mr-1" />
                {servicePoint.name}
              </span>

              {servicePoint.description && <span className="text-xs text-gray-500">{servicePoint.description}</span>}

              <span className="text-xs text-gray-500">
                {i18next.t("servicePoints:label_people_and_orders", {
                  people: servicePoint.currentPeopleCount,
                  orders: servicePoint.activeOrderCount,
                })}
              </span>
            </div>
          </div>

          <div className="flex flex-col items-end gap-2">
            <span
              className={`rounded-full px-3 py-1 text-xs font-semibold ${
                isActive ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
              }`}
            >
              {i18next.t(isActive ? "servicePoints:status_active" : "servicePoints:status_inactive")}
            </span>

            <span
              className={`rounded-full px-3 py-1 text-xs font-semibold ${
                isOccupied ? "bg-red-100 text-red-700" : "border border-slate-300 bg-white text-slate-700"
              }`}
            >
              {i18next.t(isOccupied ? "servicePoints:status_occupied" : "servicePoints:status_free")}
            </span>
          </div>
        </div>
      ),
    }
  }

  protected getItemId(item: ServicePoints): number {
    return item.id
  }
}
